import Functions from "@/utils/functions.js";

export default {

    getToken() {
        return localStorage.getItem('token')
    },

    getRefToken() {
        return localStorage.getItem('ref_token')
    },

    getDataExpiredToken() {
        return localStorage.getItem('exp_data')
    },

    getAuthHeader() {
        return 'Bearer ' + this.getToken()
    },

    checkRemember() {
        return !!localStorage.getItem('ref_token')
    },

    checkAuth() {
        return !!localStorage.getItem('token')
    },

    // Decodifica il claim del ruolo direttamente dal JWT (senza dipendenze esterne).
    // Usato dalla guardia di rotta per un controllo di usabilità immediato, PRIMA
    // ancora che lo store Vuex (popolato da /user/info) sia disponibile dopo un
    // refresh di pagina. La vera barriera di sicurezza resta comunque il backend.
    getRole() {
        const token = this.getToken()
        if (!token) return null

        try {
            const payload = token.split('.')[1]
            const decoded = JSON.parse(
                decodeURIComponent(
                    atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
                        .split('')
                        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                )
            )
            return decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || decoded["role"] || null
        } catch {
            return null
        }
    },

    getExpiration(tokenExpiration) {

        var now = new Date();
        now.setMinutes(now.getMinutes() + Math.ceil((tokenExpiration / 60)))

        return Functions.DateFormat(now);
    },

    clearStorage() {

        localStorage.clear();
    },

    logout() {

        // Pulizia storage
        this.clearStorage()

        // Pulisce lo state perchè ricarica la pagina
        window.location = '/login'

    },

    setStorage(data) {

        localStorage.setItem('token', data.access_token);
        localStorage.setItem('exp_data', this.getExpiration(data.expires_in))

        if (data.refresh_token)
            localStorage.setItem('ref_token', data.refresh_token)
    },

}
